<template>
	<b-modal
        :id="modalName"
        title="Upload File"
    >
        <b-form-file
            name="file"
            v-model="inputs.file"
            :state="Boolean(inputs.file)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
        ></b-form-file>

        <template v-slot:modal-footer>
            <b-container class="footer-block" fluid>
                <b-button type="submit" :disabled="submitting" variant="success" @click="importListings(inputs.file)">
                    <span v-if="submitting">
                        <b-spinner small type="grow"></b-spinner>
                        <strong>Submitting...</strong>
                    </span>
                    <span v-else><strong>Submit</strong></span>
                </b-button>
            </b-container>
        </template>
    </b-modal>
</template>
<script>
    export default {
        props: [ ],

        data() {
            return {
                modalName: 'QuantityUpdateUpload',
        		submitting: false,
                inputs: {
                    file: [],
                },
                success: false
            }
        },

        methods: {
            importListings(file) {
                if (file.name !== undefined) {
                    this.submitting = true
                    let formData = new FormData()
                    formData.append('file', file, file.name)

                    let url = 'api/inventory/products/quantityupdate/import'
                    axios.post(url, formData, {
                        headers: {
                        'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then((res) => {
                        if (res.data.status == 'success') {
                            this.submitting = false
                            this.closeModal(this.modalName)
                            this.showAlertBox('success', 'File Imported', 'File imported successfully! Please allow time for quantity to finish updating.')
                        }
                    }, () => {
                        this.has_error = true
                    })
                }
            },

            closeModal() {
                this.$bvModal.hide(this.modalName)
            },
        },

        mounted() {
            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                if (modalId == this.modalName) {
                    this.inputs.file = []
                    this.success = false
                }
            })
        }
    }
</script>
<style lang="scss">
    .modal-content {
        .modal-footer {
            .footer-block {
                text-align: center;
            }
        }
    }
</style>
